import { createAction } from "redux-actions";
import { createPromiseAction } from "../../utils/createPromiseAction";

export const GET_BRANDS_REQUEST = "brand/GET_BRANDS_REQUEST";
export const GET_BRANDS_SUCCESS = "brand/GET_BRANDS_SUCCESS";

export const brandActions = {
  getBrands: createPromiseAction(GET_BRANDS_REQUEST),
  getBrandsSuccess: createAction(GET_BRANDS_SUCCESS),
};
